import { TAGS, TAGS_BY_KEY } from "@/content/data";
import type { TagKey } from "@/content/types";

export function getTags(keys?: TagKey | TagKey[]) {
  if (!keys) {
    return TAGS;
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list.map(k => TAGS_BY_KEY[k]).filter(Boolean);
}
